





















































import Vue from 'vue'
import { prepareDataForApi, convertDataFromApi } from '@/utils'
import { UserProfileRequest, User, Role } from '@/types'
import { app } from '@/firebase'

export default Vue.extend({
    name: 'Admin',
    components: {
        ApplicantCard: () => import('@/components/Profile/ApplicantCard.vue'),
    },
    data: (): {
        applicants: Array<UserProfileRequest>
        members: Array<User & { verified: boolean }>
        headers: Array<{ text: string; value: string }>
    } => ({
        applicants: [],
        members: [],
        headers: ['displayName', 'uemail', 'verified', 'role', 'actions'].map((item) => ({
            text: item,
            value: item,
        })),
    }),
    mounted() {
        app.functions()
            .httpsCallable('getAllApplicants')()
            .then((res) => {
                this.applicants = JSON.parse(res.data).map((applicant: UserProfileRequest) =>
                    convertDataFromApi(applicant)
                )
            })
        this.loadMembers()
    },
    methods: {
        acceptApplicant(applicant: UserProfileRequest) {
            app.functions()
                .httpsCallable('createUserFromApplicant')(prepareDataForApi(applicant))
                .then(() => (this.applicants = this.applicants.filter((item) => item.uemail !== applicant.uemail)))
        },
        rejectApplicant(applicant: UserProfileRequest) {
            app.functions()
                .httpsCallable('rejectApplicant')(prepareDataForApi(applicant))
                .then(() => (this.applicants = this.applicants.filter((item) => item.uemail !== applicant.uemail)))
        },
        setUserRole(user: User, role: Role) {
            app.functions()
                .httpsCallable('setUserRole')({
                    id: user.id,
                    role,
                })
                .then(
                    () =>
                        (this.members = this.members.map((member) => {
                            if (member.id !== user.id) {
                                return member
                            }
                            return { ...member, role }
                        }))
                )
        },
        deleteUser(user: User) {
            app.functions()
                .httpsCallable('deleteUser')(user)
                .then(() => {
                    this.members = this.members.filter((member) => member.id !== user.id)
                })
        },
        loadMembers() {
            app.functions()
                .httpsCallable('getAllMembers')()
                .then((res) => {
                    this.members = res.data
                })
        },
    },
})
